"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTree = buildTree;
const types_1 = require("./types");
function buildHigherLayer(elements) {
    if (elements.length === 0)
        throw new Error("Cannot work on empty arrays");
    if (elements.length === 1)
        return elements[0];
    const result = [];
    let i = 0;
    while (i < elements.length - 1) {
        result.push({ type: 'node', left: elements[i], right: elements[i + 1] });
        i += 2;
    }
    if (i < elements.length)
        result.push(elements[i]);
    return buildHigherLayer(result);
}
function handleArrayContainer(items, merkleHashVersion) {
    if (items.length === 0) {
        return {
            type: 'node',
            left: types_1.emptyLeaf,
            right: types_1.emptyLeaf,
            content: [],
            size: 0,
            kind: 'array',
        };
    }
    const leaves = items.map(item => buildTree(item, merkleHashVersion));
    if (leaves.length == 1 && leaves[0].type == 'node' && merkleHashVersion >= 2) {
        return {
            type: 'node',
            left: leaves[0],
            right: types_1.emptyLeaf,
            content: items,
            size: items.length,
            kind: 'array',
        };
    }
    const root = leaves.length === 1 ? leaves[0] : buildHigherLayer(leaves);
    if (root.type === 'node') {
        return { ...root, content: items, size: items.length, kind: 'array' };
    }
    return {
        type: 'node',
        left: root,
        right: types_1.emptyLeaf,
        content: items,
        size: items.length,
        kind: 'array',
    };
}
function handleDictContainer(items, merkleHashVersion) {
    if (items.length === 0) {
        return {
            type: 'node',
            left: types_1.emptyLeaf,
            right: types_1.emptyLeaf,
            content: [],
            size: 0,
            kind: 'dict',
        };
    }
    const leaves = [];
    for (const [key, value] of items) {
        leaves.push({ type: 'leaf', content: key });
        leaves.push(buildTree(value, merkleHashVersion));
    }
    const root = leaves.length === 2
        ? { left: leaves[0], right: leaves[1] }
        : buildHigherLayer(leaves);
    if ('left' in root && 'right' in root) {
        return {
            type: 'node',
            left: root.left,
            right: root.right,
            content: items,
            size: items.length,
            kind: 'dict',
        };
    }
    return {
        type: 'node',
        left: root,
        right: types_1.emptyLeaf,
        content: items,
        size: items.length,
        kind: 'dict',
    };
}
function buildTree(value, merkleHashVersion) {
    if (Array.isArray(value)) {
        return handleArrayContainer(value, merkleHashVersion);
    }
    if (typeof value === 'object' && value !== null && !Buffer.isBuffer(value)) {
        const entries = Object.entries(value);
        return handleDictContainer(entries, merkleHashVersion);
    }
    return { type: 'leaf', content: value };
}
//# sourceMappingURL=factory.js.map